/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Image_LabelInputs */



/**
* | output |
* | --- |
* | "Image" |
*
* @param {Promo_Image_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_image_label = /** @type {((inputs?: Promo_Image_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Image_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Image")
	if (locale === "es") return /** @type {LocalizedString} */ ("Imagen")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Imagem")
	if (locale === "it") return /** @type {LocalizedString} */ ("Immagine")
	return /** @type {LocalizedString} */ ("Image")
});